import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorComponentComponent } from './error-component/error-component.component';
import { TopheaderComponent } from './topheader/topheader.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { SiteFooterComponent } from './site-footer/site-footer.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { AlphaLinkbarComponent } from './alpha-linkbar/alpha-linkbar.component';
import { DropdownMultiselectComponent } from './dropdown-multiselect/dropdown-multiselect.component';
import { AccessrestrictedComponent } from './accessrestricted/accessrestricted.component';
import { SafeHtmlPipe } from './pipe/safe-html.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule
  ],
  declarations: [
    TopheaderComponent,
    SidebarComponent,
    SiteFooterComponent,
    SpinnerComponent,
    ErrorModalComponent,
    ErrorComponentComponent,
    AlphaLinkbarComponent,
    AccessrestrictedComponent,
    SafeHtmlPipe,
    DropdownMultiselectComponent
  ],
  exports: [
    TopheaderComponent,
    SiteFooterComponent,
    SidebarComponent,
    SpinnerComponent,
    AlphaLinkbarComponent,
    SafeHtmlPipe,
    DropdownMultiselectComponent,
    DataTablesModule
  ],
  // entryComponents: [
  //   ErrorModalComponent,
  //   CustomerModalComponent,
  // ],
  providers: [
    TopheaderComponent,
    NgSelectModule
  ],
})
export class SharedModule { }
